import React, { useState } from "react";
import { ChevronUp, ChevronDown } from "lucide-react";
import { cn } from "@/utils";

interface AccordionSectionProps {
  label: React.ReactNode;
  children: React.ReactNode;
  defaultOpen?: boolean;
  className?: string;
  noBorder?: boolean;
}

const AccordionSection: React.FC<AccordionSectionProps> = ({
  label,
  children,
  defaultOpen = false,
  className,
  noBorder = false,
}) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <div className={cn(className, !noBorder && "border-t border-line")}>
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        className="w-full flex items-center justify-between py-3 px-0 group"
      >
        <h3 className="font-heading text-fs-md font-semibold tracking-[-0.012em] text-ink-1">{label}</h3>
        {isOpen ? (
          <ChevronUp className="h-4 w-4 text-ink-3 group-hover:text-ink-1 transition-colors" strokeWidth={2} />
        ) : (
          <ChevronDown className="h-4 w-4 text-ink-3 group-hover:text-ink-1 transition-colors" strokeWidth={2} />
        )}
      </button>
      {isOpen && <div className="space-y-4 pb-3">{children}</div>}
    </div>
  );
};

export default AccordionSection;
